import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {clientAPI} from "./axiosAnstance";
import axios from "axios";
import {SERVER_URL} from "../../../serverConfig";
import {getAuthHeader} from "../../../jwt/config";
import fileDownload from "js-file-download";





//
export const listAssuranceDemandeAPI = createAsyncThunk(
  "aid/listAssuranceDemandeAPI",
  async (data) => {
    const url = `/api/assuranceAdmin/getDemandes`;
    const response = await clientAPI.get(url);
    return response.data;
  }
);
export const listAidDemandeTraiteAPI = createAsyncThunk(
  "adha/listAidDemandeTraiteAPI",
  async (data) => {
    const url = `/api/adha/listeDemandeTraite`;
    const response = await clientAPI.get(url);
    return response.data;
  }
);
export const traiteDemandeAidAPI = createAsyncThunk(
  "adha/traiteDemandeAidAPI",
  async ({ id }, thunkAPI) => {
    try {
      const url = `/api/adha/traiteDemande/${id}`;
      const response = await clientAPI.post(url);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);


export const refuserAdhaAPI = createAsyncThunk(
  "adha/refuserAdhaAPI",
  async (data) => {
    const formData = new FormData();
    formData.append("idDemande", data.idDemande);
    formData.append("motifRefus", data.motifRefus);
    const response = await clientAPI.post("/api/adha/refusDemande", formData);
    return response.data;
  }
);
export const supprimerAssuranceAPI = createAsyncThunk(
  "soutient/supprimerAssuranceAPI",
  async ( id , thunkAPI) => {
    try {
      const url = `/api/assuranceAdmin/supprimer/${id}`;
      const response = await clientAPI.post(url);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
export const validationAssuranceAPI = createAsyncThunk(
  "soutient/validationAssuranceAPI",
  async ({ id }, thunkAPI) => {
    try {
      const url = `/api/assuranceAdmin/validation/${id}`;
      const response = await clientAPI.post(url);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
export const listDemandeFilterAPI = createAsyncThunk(
  "adha/listDemandeFilterAPI",
  async (data) => {
    //const url = `/api/colonie/listColonie`;
    const response = await clientAPI.post("/api/adha/filter",data);
    return response.data;
  }
);



export const listTypeFichierAssuranceSavedAPI = createAsyncThunk(
  "estivage/listTypeFichierAssuranceSavedAPI",
  async (idDemande) => {
    const response = await clientAPI.get("/api/assuranceAdmin/listeTypeFichierSaved/" + idDemande);
    return response.data;
  }
);

export const getFileAssuranceByDemandeAndType = createAsyncThunk(
  "estivage/getFileAssuranceByDemandeAndType",
  async (data) => {
    return axios
      .get(
        SERVER_URL +
        `/api/assuranceAdmin/getFileByDemandeAndType/${data.idDemande}/${data.id_type_fichier}`,
        {
          headers: getAuthHeader(),
          responseType: "blob",
        }
      )
      .then((res) => {
        return res.data;
      });
  }
);

export const AddCommentaireAPI = createAsyncThunk(
  "assuranceAdmin/AddCommentaireAPI",
  async (data) => {
    const response = await clientAPI.post("/api/assuranceAdmin/commenatire", data);
    return response.data;
  }
);


const Assurance = createSlice({
  name: "assurance",
  initialState: {
    listeDemande : [],
    listeDemandeTraite : [],
    listeTypeFichierSaved : [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listAssuranceDemandeAPI.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.listeDemande = action.payload;
      })
      .addCase(listTypeFichierAssuranceSavedAPI.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.listeTypeFichierSaved = action.payload;
      })
      .addCase(listDemandeFilterAPI.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.listeDemande = action.payload;
      })
      .addCase(listAidDemandeTraiteAPI.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.listeDemandeTraite = action.payload;
      })

  },
});


export const {} = Assurance.actions;

export default Assurance.reducer;
